export default "__VITE_ASSET__B1kGk1Fd__"